import apiSlice from "../api/apiSlice";

export const bilateralPricesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getBilateralPricesByCommunityIdPagination: builder.query({
      query: ({
        limit,
        page,
        date,
        time,
        receiverUserId,
        providerUserId,
        communityId,
        sortColumn,
        sortDirection,
      }) => ({
        url:
          `/communities/${communityId}/bilateral-prices/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${receiverUserId ? `&receiver_user_id=${receiverUserId}` : ""}` +
          `${providerUserId ? `&provider_user_id=${providerUserId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "BilateralPrice", id: "LIST" }],
    }),
    /* GET by provider + time range */
    getBilateralPricesByProvider: builder.query({
      query: ({ communityId, providerUserId, startDate, endDate }) => ({
        url:
          `/communities/${communityId}/bilateral-prices/by_provider?` +
          `provider_user_id=${providerUserId}&` +
          `start_date=${startDate}&` +
          `end_date=${endDate}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "BilateralPrice", id: "BY_PROVIDER" }],
    }),
    /* GET heatmap — aggregated avg price per provider-receiver pair */
    getBilateralPricesHeatmap: builder.query({
      query: ({ communityId, startDatetime, endDatetime }) => ({
        url:
          `/communities/${communityId}/bilateral-prices/heatmap?` +
          `start_datetime=${encodeURIComponent(startDatetime)}&` +
          `end_datetime=${encodeURIComponent(endDatetime)}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "BilateralPrice", id: "HEATMAP" }],
    }),
    /* POST */
    addNewBilateralPrices: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/bilateral-prices/file_upload`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "BilateralPrice", id: "LIST" }],
    }),
    /* Fixed Bilateral Prices */
    getFixedBilateralPrices: builder.query({
      query: ({ communityId }) => ({
        url: `/communities/${communityId}/bilateral-prices/fixed`,
        method: "GET",
      }),
      providesTags: () => [{ type: "FixedBilateralPrice", id: "LIST" }],
    }),
    upsertFixedBilateralPrices: builder.mutation({
      query: ({ communityId, prices }) => ({
        url: `/communities/${communityId}/bilateral-prices/fixed`,
        method: "POST",
        body: prices,
      }),
      invalidatesTags: [{ type: "FixedBilateralPrice", id: "LIST" }],
    }),
    updateFixedBilateralPrice: builder.mutation({
      query: ({ communityId, receiverUserId, providerUserId, price }) => ({
        url: `/communities/${communityId}/bilateral-prices/fixed/${receiverUserId}/${providerUserId}`,
        method: "PUT",
        body: { price },
      }),
      invalidatesTags: [{ type: "FixedBilateralPrice", id: "LIST" }],
    }),
    deleteFixedBilateralPrice: builder.mutation({
      query: ({ communityId, receiverUserId, providerUserId }) => ({
        url: `/communities/${communityId}/bilateral-prices/fixed/${receiverUserId}/${providerUserId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "FixedBilateralPrice", id: "LIST" }],
    }),
  }),
});

export const {
  useGetBilateralPricesByCommunityIdPaginationQuery,
  useGetBilateralPricesByProviderQuery,
  useGetBilateralPricesHeatmapQuery,
  useAddNewBilateralPricesMutation,
  useGetFixedBilateralPricesQuery,
  useUpsertFixedBilateralPricesMutation,
  useUpdateFixedBilateralPriceMutation,
  useDeleteFixedBilateralPriceMutation,
} = bilateralPricesApiSlice;
